import base from "./base"; // 导入接口域名列表
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const getConfig = {
  
  get_iden(params) {
    return axios.post(`${base.bd}/mobile/config/find_iden`, qs.stringify(params));
  },
  get_idenMore(params) {
    return axios.post(`${base.bd}/mobile/config/lists_iden`, qs.stringify(params));
  },
  
};
export default getConfig;
